interface FunnelStage {
  stage: string;
  count: number;
  percentage: number;
}

interface ConversionFunnelProps {
  data: FunnelStage[];
}

export const ConversionFunnel = ({ data }: ConversionFunnelProps) => {
  return (
    <div className="space-y-3">
      {data.map((stage, index) => {
        const dropRate = index > 0 && data[index - 1] 
          ? Math.round(100 - (stage.count / data[index - 1].count * 100))
          : 0;
        
        return (
          <div key={stage.stage} className="space-y-1">
            <div className="flex justify-between text-sm">
              <span className="font-medium">{stage.stage}</span>
              <span className="font-semibold">
                {stage.count.toLocaleString()} ({stage.percentage}%)
              </span>
            </div>
            <div className="relative h-12 bg-muted rounded-lg overflow-hidden">
              <div 
                className="absolute inset-y-0 left-0 bg-gradient-to-r from-primary to-primary/60 transition-all duration-500"
                style={{ width: `${stage.percentage}%` }}
              />
              {index > 0 && dropRate > 0 && (
                <span className="absolute inset-0 flex items-center justify-center text-xs font-medium text-destructive z-10">
                  ↓ {dropRate}% de perda
                </span>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};
